import React, { useState, useRef } from "react";
import { Flex, Stack, Heading, Text, Link, Box, FormLabel, Input, Button } from "@chakra-ui/react";
import { Form, Formik, useField } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import CommonVars from "../components/CommonVars";

const CustomForgotPwdInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <>
            <FormLabel htmlFor={props.id || props.name} pt={2}>{label}</FormLabel>
            <Input className='text-input' {...field} {...props} mt={[0, "0px !important"]}/>
            {meta.touched && meta.error ? (
                <div className='error'>{meta.error}</div>
            ) : null}
        </>
    )
}

function ForgotPasswordScreen() {
    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    return (
        <Formik
            initialValues={{
                email: '',
            }}
            validationSchema={Yup.object({
                email: Yup.string()
                .email('Invalid Email Address')
                .required('Email is required'),
            })}
            onSubmit = {(values, { setSubmitting, resetForm }) => {
                const forgotPwdEmailInput = values.email;
                // access backend to check if email exists
                axios.get(`${CommonVars.API_URL}/forgot-password/${forgotPwdEmailInput}`)
                .then((response) => {
                    const fpEmail = response.data[0].email;
                    const fpUserid = response.data[0].userid;
                    // prepare request body for forgot password email sending
                    const forgotPwdRequestBody = {
                        email: fpEmail,
                        userid: fpUserid,
                    }
                    // access backend to send reset password email
                    axios.post(`${CommonVars.API_URL}/forgot-password/`, forgotPwdRequestBody)
                    .then(() => {
                        setSuccessMsg(`A reset password email was sent!`);
                        setSubmitting(false);
                        resetForm();
                    })
                    .catch((error) => {
                        console.log(error);
                        setErrMsg(`Something went wrong...`);
                        setSubmitting(false);
                        setTimeout(() => {
                            setErrMsg();
                            console.clear();
                        }, 6000);
                    });
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        setErrMsg(`Email entered could'nt be found.`);
                        setSubmitting(false);
                        setTimeout(() => {
                            setErrMsg();
                            console.clear();
                        }, 3500);
                    } else {
                        setErrMsg(`Something went wrong...`);
                        setTimeout(() => {
                            setErrMsg();
                            console.clear();
                        }, 4000)
                        setSubmitting(false);
                    }
                });
            }}
        >
            {props => (
                <Flex  
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                        <Stack align={'center'}>
                            <Heading fontSize={'4xl'}>Forgot your password?</Heading>
                            <Text fontSize={'md'} pt={2} color={'gray.600'}>
                                Fear not! We'll email you a link to reset your password.
                            </Text>
                        </Stack>
                        <Box
                            rounded={'lg'}
                            bg={'white'}
                            boxShadow={'lg'}
                            px={8}
                            py={6}
                        >
                            <Form>
                                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p>
                                <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
                                {/* Email Input */}
                                <Stack spacing={5}> 
                                    <CustomForgotPwdInput 
                                        label="Email" 
                                        name="email" 
                                        type="text"
                                        placeholder="Enter Email Address"
                                    />
                                    {/* Submit email button */}
                                    <Button
                                        type="submit"
                                        fontSize={16}
                                        bg={'black'}
                                        color={'white'}
                                        _hover={{
                                        bg: '#37404A',
                                        }}
                                    >
                                        {props.isSubmitting ? 'Sending Email...' : 'Send password reset email'}
                                    </Button>
                                    <Link align="center" color={'#37404A'} href="/login">Return to login</Link>
                                </Stack>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            )}
        </Formik>
    )
}

export default ForgotPasswordScreen;